import * as React from "react";
import { NavMenu } from "./NavMenu";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import * as MeState from "../store/Me";
import * as Auth0State from "../store/Auth0";
import Navbar from "./navbar/Navbar";
import Sidebar from "./sidebar/Sidebar";
import SidebarTailwind from "./sidebar/SidebarTailwind";
import TenantSwitcherDialog from "./Tenants/TenantSwitcherDialog";
import { useFeatureFlags } from "shared/context/FeatureFlags";
import { useSidebarState } from "shared/context/SidebarState";
import { TenantSwitcherProvider } from "shared/context/TenantSwitcherState";

type OwnProps = {
  children?: React.ReactNode;
};

type Props = {
  me: MeState.MeState;
  auth0: Auth0State.Auth0State;
} & OwnProps;

const LayoutComponent: React.FC<Props> = ({ children }) => {
  const { flags } = useFeatureFlags();
  const { collapsed } = useSidebarState();

  if (flags.sidebar) {
    return (
      <TenantSwitcherProvider>
        <div className="min-h-screen bg-slate-100">
          <SidebarTailwind />
          <div
            className={`transition-all duration-300 ${collapsed ? "md:pl-16" : "md:pl-64"}`}
          >
            <Navbar />
            <div className="mx-8 mb-8">{children}</div>
          </div>
        </div>
        <TenantSwitcherDialog />
      </TenantSwitcherProvider>
    );
  }

  return (
    <TenantSwitcherProvider>
      <div className="flex min-h-screen h-full flex-row flex-grow my-auto bg-slate-100">
        <div className="sm:hidden md:flex md:mr-10 md:relative ">
          <Sidebar />
        </div>

        <div className="flex-1 max-sm:w-full  mx-auto max-h-screen overflow-scroll">
          <Navbar />
          <div className="mx-8 mb-8">{children}</div>
        </div>
      </div>
      <TenantSwitcherDialog />
    </TenantSwitcherProvider>
  );
};

export const Layout = connect<
  { me: MeState.MeState; auth0: Auth0State.Auth0State },
  {},
  OwnProps,
  ApplicationState
>((state) => ({
  me: state.me,
  auth0: state.auth0,
}))(LayoutComponent);
